import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const SafeMailingListsOptionV2: LazyOption = createLazyOption(
    {
        key: 'safeMailingListsV2',
        titleStringKey: 'optionTitle_safeMailingLists',
        searchTermsStringKey: 'optionSearchTerms_safeMailingLists',
        isHidden: () => {
            return (
                !isFeatureEnabled('tri-spamV2SenderDomain') ||
                IsShadowMailboxUser() ||
                !isConsumer()
            );
        },
    },
    lazyFullModule,
    m => m.default
);
export default SafeMailingListsOptionV2;
